import { useContext } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useCreateAction from "../actions/create/useCreateAction";
import useEditAction from "../actions/edit/useEditAction";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import useGeneratePDFAction from "../actions/generate-pdf/GeneratePDFAction";
import useDownloadPDFAction from "../actions/download-pdf/DownloadPDFAction";
import useReplicateAction from "../actions/replicate/useReplicateAction";
import { ReplicateActionProvider } from "../actions/replicate/ReplicateActionContext";

function DeliveryNotesPage(props: any) {
  const { filters, formDefaultValues, formWidgets, deliveryNoteConfiguration, showReceiverAccountSelector } =
    props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(
      indexFunction,
      formDefaultValues,
      formWidgets,
      deliveryNoteConfiguration,
      showReceiverAccountSelector
    );

  const { getFunction, actionTemplate: editActionTemplate } = useEditAction(
    indexFunction,
    formDefaultValues,
    formWidgets,
    deliveryNoteConfiguration,
    showReceiverAccountSelector
  );

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);

  const {
    initializeFunction: initializeGeneratePDFFunction,
    actionTemplate: generateGeneratePDFActionTemplate,
  } = useGeneratePDFAction(indexFunction);

  const { downloadPDFFunction: downloadPDFFunction } = useDownloadPDFAction();

  const { prepareReplicateFunction, actionTemplate: replicateActionTemplate } = useReplicateAction(getFunction);

  let tableConfig = getConfig({
    initializeFunction,
    indexFunction,
    getFunction,
    prepareRemoveFunction,
    initializeGeneratePDFFunction,
    downloadPDFFunction,
    replicateDeliveryNoteFunction: prepareReplicateFunction,
  });
  setTableConfig(tableConfig);

  return (
    <ReplicateActionProvider>
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
        <span>{t("Delivery Notes")}</span>
        <div>
          <BeelditTableHeaderActions
            actions={tableConfig.actions}
          ></BeelditTableHeaderActions>
        </div>
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {editActionTemplate}
        {removeActionTemplate}
        {generateGeneratePDFActionTemplate}
        {replicateActionTemplate}
      </Card.Body>
    </Card>
    </ReplicateActionProvider>
  );
}

export default DeliveryNotesPage;
